/**
* @Author: zhangxiaojian
* @Date: 2025/10/14
* @LastEditors: zhangxiaojian
* @Description 图片存储或附件存储前缀枚举值
**/
const STORAGE_SUFFIX = '-block'
export default {
  /**
   * 存储资源统一后缀
   */
  STORAGE_SUFFIX,
  /**
   * 图片存储
   */
  IMAGE: 'qBp' + STORAGE_SUFFIX,
  /**
   * 纸媒存储
   */
  PRINT_MEDIA: 'rTks' + STORAGE_SUFFIX,
  /**
   * 模板存储
   */
  TEMPLATE: 'xDfm' + STORAGE_SUFFIX,
  /**
   * 外网存储
   */
  EXTERNAL_NETWORK: 'jGnw' + STORAGE_SUFFIX,
  /**
   * 视音频存储
   */
  AUDIO_VISUAL: 'pHvt' + STORAGE_SUFFIX,
  /**
   * 视音频外网存储
   */
  EXTERNAL_AUDIO_VISUAL: 'sKcr' + STORAGE_SUFFIX,
  /**
   * 视音频资产存储
   */
  AUDIO_VISUAL_PRODUCE: 'dQxb' + STORAGE_SUFFIX,
  /**
   * 图片资产存储
   */
  IMAGE_PRODUCE: 'mFsg' + STORAGE_SUFFIX,
  /**
   * 期刊存储
   */
  JOURNAL: 'zLwh' + STORAGE_SUFFIX,
  /**
   * 附件存储
   */
  ATTACHMENT: 'fwcc' + STORAGE_SUFFIX,
  /**
   * 文档存储
   */
  DOCUMENT: 'dtsc' + STORAGE_SUFFIX,
  /**
   * 文档资产存储
   */
  DOCUMENTAS: 'dtscas' + STORAGE_SUFFIX

}
